import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import Footer from "../components/Footer";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", password: "",
    birth_date: "", gender: "feminino", looking_for: "masculino",
  });
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("A palavra-passe deve ter pelo menos 6 caracteres.");
      return;
    }
    if (!form.birth_date) {
      toast.error("Indica a tua data de nascimento.");
      return;
    }
    setBusy(true);
    try {
      await register({ ...form });
      toast.success("Conta criada. Vamos conhecer-te melhor.");
      navigate("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível registar.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#0C0E12]" data-testid="register-page">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-10">
          <Heart className="w-5 h-5 text-[#C5A880]" />
          <span className="font-display text-2xl">Soulmatch</span>
        </Link>

        <div className="bg-[#161920] border border-white/5 rounded-2xl p-10">
          <span className="label-uppercase">Registo</span>
          <h1 className="font-display text-3xl mt-3 mb-8">Cria a tua conta</h1>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-xs text-[#A29F9B]">Nome</label>
              <input className="input-elegant" required value={form.name}
                onChange={(e)=>set("name", e.target.value)} placeholder="O teu nome próprio"
                data-testid="register-name" />
            </div>
            <div>
              <label className="text-xs text-[#A29F9B]">Email</label>
              <input type="email" className="input-elegant" required value={form.email}
                onChange={(e)=>set("email", e.target.value)} placeholder="o-teu-email@exemplo.pt"
                data-testid="register-email" />
            </div>
            <div>
              <label className="text-xs text-[#A29F9B]">Palavra-passe</label>
              <input type="password" className="input-elegant" required value={form.password}
                onChange={(e)=>set("password", e.target.value)} placeholder="Mínimo 6 caracteres"
                data-testid="register-password" />
            </div>

            <div>
              <label className="text-xs text-[#A29F9B]">Data de nascimento</label>
              <input type="date" required className="input-elegant"
                max={new Date(Date.now() - 18 * 365.25 * 86400000).toISOString().slice(0, 10)}
                value={form.birth_date} onChange={(e)=>set("birth_date", e.target.value)}
                data-testid="register-birth-date" />
              <p className="text-[10px] text-[#A29F9B]/70 mt-1">Tens de ter pelo menos 18 anos.</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-xs text-[#A29F9B]">Sou</label>
                <select className="input-elegant bg-[#161920]" value={form.gender}
                  onChange={(e)=>set("gender", e.target.value)} data-testid="register-gender">
                  <option value="feminino">Mulher</option>
                  <option value="masculino">Homem</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
              <div>
                <label className="text-xs text-[#A29F9B]">Procuro</label>
                <select className="input-elegant bg-[#161920]" value={form.looking_for}
                  onChange={(e)=>set("looking_for", e.target.value)} data-testid="register-looking">
                  <option value="feminino">Mulheres</option>
                  <option value="masculino">Homens</option>
                  <option value="ambos">Ambos</option>
                </select>
              </div>
            </div>

            <button type="submit" disabled={busy} className="btn-primary w-full mt-4" data-testid="register-submit">
              {busy ? "A criar conta..." : "Criar conta"}
            </button>
          </form>

          <p className="text-sm text-[#A29F9B] mt-6 text-center">
            Já tens conta?{" "}
            <Link to="/login" className="text-[#C5A880] hover:underline" data-testid="register-go-login">
              Entrar
            </Link>
          </p>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
